import DataTable, {Order} from "datatables.net-bs5";
import * as Highcharts from "highcharts";
import {on} from "../util";
import { getChartTheme } from "../utils/chartTheme";
declare const eo_version : string;
declare const mobs_array : any[];
declare const mobs_gold_array : any[];
declare const mobs_exp_array : any[];
declare const items_array : any[];
declare const items_gold_array : any[];
declare const items_exp_array : any[];
declare const dates_array : string[];
declare const interval : number;
declare const my_day_date : string;

let date : Date;

export default class {
    static init = () => {
        init_date();
        my_kills();
        my_kills_history();
        my_gathered();
        my_gathering_history();
        my_day();
    }
}

function init_date() {
    if(typeof my_day_date !== 'undefined') {
        date = new Date(my_day_date + ' 12:00:00');
    } else {
        date = new Date();
    }
}

function my_kills() {
    let table = document.querySelector('.datatable[data-table="my_kills"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="my_kills"]',{
        pageLength: 10,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getMyKills',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: null, className: "align-middle", render: function(data) {
                    return `<div class="text-center"><a href="/eo/mobs/${data.npc_id}"><img src="/assets/eo/${eo_version}/npc/${data.npc_id}.png" class="eo-item-image-medium" /><div>${data.mob}</div></a></div>`;
                }},
            { data: 'kills', className: "align-middle" },
            { data: 'exp', className: "align-middle" },
            { data: null, className: "align-middle td-drops", render: function(data : any) {
                    if(data.drops.length == 0) {
                        return '-';
                    }
                    let dropsDiv = document.createElement('div');
                    dropsDiv.className = 'table-drops';
                    data.drops.forEach((drop : any) => {
                        let dropDiv = document.createElement('div');
                        dropDiv.className = 'table-drop';
                        dropDiv.innerHTML = `<img src="/assets/eo/${eo_version}/items/${drop.id}.png" class="eo-item-image-small" /> <a href="/eo/items/${drop.id}">${drop.name}</a> x ${drop.count} <small>(${drop.rate}%)</small>`;
                        dropsDiv.appendChild(dropDiv);
                    });
                    return dropsDiv.outerHTML;
                }, width: '18%' },
            { data: 'total_gold', className: "align-middle" },
            { data: 'avg_gold', className: "align-middle" },
            { data: 'ttk', className: "align-middle" },
            { data: 'time', className: "align-middle" },
            { data: 'kills_hour', className: "align-middle" },
            { data: 'hour_gold', className: "align-middle" },
            { data: 'hour_exp', className: "align-middle" },
        ],
        order: [[1,"desc"]] as Order[]
    });
}

function my_gathered() {
    let table = document.querySelector('.datatable[data-table="my_gathered"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="my_gathered"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getMyGathering',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: null, className: "align-middle", render: function(data) {
                    return `<img src="/assets/eo/${eo_version}/items/${data.item_id}.png" class="eo-item-image-small" /> <a href="/eo/items/${data.item_id}">${data.item}</a>`;
                }},
            { data: 'gathered', className: "align-middle" },
            { data: 'exp', className: "align-middle" },
            { data: 'total_gold', className: "align-middle" },
            { data: 'avg_gold', className: "align-middle" },
            { data: 'ttg', className: "align-middle" },
            { data: 'gathered_hour', className: "align-middle" },
            { data: 'hour_gold', className: "align-middle" },
        ],
        order: [[1,"desc"]] as Order[]
    });
}

function my_kills_history() {
    let chart : Highcharts.Chart;

    if(typeof mobs_array !== 'undefined') {
        const button_background = getComputedStyle(document.documentElement).getPropertyValue('--ksat-surface-raised').trim();
        let gold_color = 'rgb(255, 255, 0, 0.3)';
        let exp_color = 'rgb(65,211,255,0.3)';

        let series: Highcharts.SeriesOptionsType[] = [];
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Profit',
            data: mobs_gold_array,
            visible: true,
            yAxis: 1,
            color: 'rgb(255, 255, 0, 0.3)',
            showInLegend: false,
            tooltip: {
                valueSuffix: ' eons',
            }
        });
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Experience',
            data: mobs_exp_array,
            visible: true,
            yAxis: 2,
            color: exp_color,
            showInLegend: false,
            tooltip: {
                valueSuffix: ' exp',
            }
        });
        mobs_array.forEach((mob) => {
            let data = mob.data;
            //@ts-ignore
            series.push({
                type: 'column',
                name: mob.name,
                data: data,
                visible: true,
                // connectNulls: true,
                color: mob.color
            });
        });

        // @ts-ignore
        chart = Highcharts.chart("chart_eo_kill_history", Highcharts.merge(getChartTheme(), {
            series: series as Highcharts.SeriesOptionsType[],
            chart: {
                height: 500,
                zooming: {
                    type: 'x',
                    resetButton: {
                        position: {
                            align: "right",
                            x: 0,
                            y: -30
                        },
                        theme: {
                            fill: button_background,
                            stroke: "none",
                            style: {
                                backgroundColor: button_background
                            },
                            states: {
                                hover: {
                                    fill: button_background,
                                    style: {
                                        backgroundColor: button_background
                                    }
                                }
                            }
                        }
                    }
                },
            },
            title: {
                text: 'My Kills History',
                // align: 'left',
                style: {
                    fontSize: '14px'
                }
            },
            legend: {
                enabled: true,
            },
            //@ts-ignore
            xAxis: {
                type: 'datetime',
                labels: {
                    overflow: 'justify',
                }
            },
            yAxis: [{
                title: {
                    text: '',
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                // @ts-ignore
                alternateGridColor: null,
                allowDecimals: false
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: gold_color
                    }
                },
                labels: {
                    style: {
                        color: gold_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: exp_color
                    }
                },
                labels: {
                    style: {
                        color: exp_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            }],
            tooltip: {
                valueSuffix: ' kills',
                xDateFormat: '%b %e, %Y %H:%M'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    borderWidth: 0,
                    states: {
                        hover: {
                            borderWidth: 1,
                        }
                    },
                    pointInterval: interval,
                    pointStart: Date.parse(dates_array[0]) - (1000 * 60 * 60 * 4),
                },
                spline: {
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 3
                        }
                    },
                    marker: {
                        enabled: false
                    },
                    pointInterval: interval,
                    pointStart: Date.parse(dates_array[0]) - (1000 * 60 * 60 * 4),
                },
            },
            credits: {
                enabled: false
            }
        } as any) as Highcharts.Chart);
    }
}

function my_gathering_history() {
    let chart : Highcharts.Chart;

    if(typeof items_array !== 'undefined') {
        const button_background = getComputedStyle(document.documentElement).getPropertyValue('--ksat-surface-raised').trim();
        let gold_color = 'rgb(255, 255, 0, 0.3)';
        let exp_color = 'rgb(65,211,255,0.3)';

        let series: Highcharts.SeriesOptionsType[] = [];
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Profit',
            data: items_gold_array,
            visible: true,
            yAxis: 1,
            color: gold_color,
            showInLegend: false,
            tooltip: {
                valueSuffix: ' eons',
            }
        });
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Experience',
            data: items_exp_array,
            visible: true,
            yAxis: 2,
            color: exp_color,
            showInLegend: false,
            tooltip: {
                valueSuffix: ' exp',
            }
        });
        items_array.forEach((item) => {
            let data = item.data;
            series.push({
                type: 'column',
                name: item.name,
                data: data,
                visible: true,
                // connectNulls: true,
                color: item.color
            });
        });

        chart = Highcharts.chart("chart_eo_gathering_history", Highcharts.merge(getChartTheme(), {
            series: series as Highcharts.SeriesOptionsType[],
            chart: {
                height: 500,
                zooming: {
                    type: 'x',
                    resetButton: {
                        position: {
                            align: "right",
                            x: 0,
                            y: -30
                        },
                        theme: {
                            fill: button_background,
                            stroke: "none",
                            style: {
                                backgroundColor: button_background
                            },
                            states: {
                                hover: {
                                    fill: button_background,
                                    style: {
                                        backgroundColor: button_background
                                    }
                                }
                            }
                        }
                    }
                },
            },
            title: {
                text: 'My Gathering History',
                // align: 'left',
                style: {
                    fontSize: '14px'
                }
            },
            legend: {
                enabled: true,
            },
            //@ts-ignore
            xAxis: {
                type: 'datetime',
                labels: {
                    overflow: 'justify',
                }
            },
            yAxis: [{
                title: {
                    text: '',
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                // @ts-ignore
                alternateGridColor: null,
                allowDecimals: false
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: gold_color
                    }
                },
                labels: {
                    style: {
                        color: gold_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: exp_color
                    }
                },
                labels: {
                    style: {
                        color: exp_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            }],
            tooltip: {
                valueSuffix: ' collected',
                xDateFormat: '%b %e, %Y %H:%M'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    borderWidth: 0,
                    states: {
                        hover: {
                            borderWidth: 1,
                        }
                    },
                    pointInterval: interval,
                    pointStart: Date.parse(dates_array[0]) - (1000 * 60 * 60 * 4),
                },
                spline: {
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 3
                        }
                    },
                    marker: {
                        enabled: false
                    },
                    pointInterval: interval,
                    pointStart: Date.parse(dates_array[0]) - (1000 * 60 * 60 * 4),
                }
            },
            credits: {
                enabled: false
            }
        } as any) as Highcharts.Chart);
    }
}

function my_day() {
    if(typeof items_array === 'undefined' && typeof mobs_array === 'undefined') {
        return;
    }

    on('click', '.js-eo-day-prev', () => {
        date.setDate(date.getDate() - 1);
        goto();
    });

    on('click', '.js-eo-day-next', () => {
        date.setDate(date.getDate() + 1);
        goto();
    });

    function goto() {
        window.location.href = '/eo/my-day/history/' + date.toISOString().slice(0,10);
    }
}
